// Tokens available in scheduled report email templates
const SCHEDULE_CATEGORY = 'schedule';

const scheduleTokens = {
  report: [
    { token: 'reportName',    previewValue: 'Monthly Circulation Report', allowedFor: [SCHEDULE_CATEGORY] },
    { token: 'date',          previewValue: '2026-09-09 09:00 UTC',        allowedFor: [SCHEDULE_CATEGORY] },
    { token: 'format',        previewValue: 'EXCEL',                       allowedFor: [SCHEDULE_CATEGORY] },
    { token: 'records',       previewValue: '1415',                        allowedFor: [SCHEDULE_CATEGORY] },
  ],
  recipient: [
    { token: 'recipientName', previewValue: 'John Smith',                  allowedFor: [SCHEDULE_CATEGORY] },
  ],
};

export { SCHEDULE_CATEGORY };
export default scheduleTokens;
